export const UPLOAD_STATUS = {
  DOWNLOADING: "downloading",
  PENDING: "pending",
  STARTED: "started",
  COMPLETED: "completed",
  ERROR: "error",
} as const;

export type UploadStatusKeys = keyof typeof UPLOAD_STATUS;

export type UploadStatus = (typeof UPLOAD_STATUS)[UploadStatusKeys];
